import React from 'react'

const Attribution = () => {
  return (
    <div className="attribution absolute pb-6 text-xs text-grayish-blue mx-auto flex justify-center w-full" role="contentinfo">
      <div>Challenge by<a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noopener noreferrer" className='text-dark-grayish-blue hover:text-orange'> Frontend Mentor</a></div>
      <div>. Coded by <a href="https://github.com/Hikmahx" className='text-dark-grayish-blue hover:text-orange'> Hikmah</a>.</div>
    </div>

  )
}

export default Attribution